import React from "react";
import {useLayoutEffect, useRef, useState} from 'react';
import ReactDOM from 'react-dom/client';
import reactToWebComponent from "react-to-webcomponent";
import TnWebCam from "./components/TnWebCam";
import PropTypes from 'prop-types';
import { Provider } from 'react-redux'
import configureStore from "./store/configureStore";
//import styles from './App.css';
import './css/multiple-v2/image-gallery.css';
import './css/multiple-v2/slick.css';
import './css/multiple-v2/slick-theme.css';
import './css/multiple-v2/react-datepicker.css';
import './css/multiple-v2/Range.css';
import './css/multiple-v2/App.css';
import './css/multiple-v2/Sidebar.css';
import './css/multiple-v2/Tempslider.css';


const store = configureStore();

function getParentZIndexValues(element) {
    const zIndexValues = [];
    let currentElement = element;
    
    while (currentElement !== null) {
        const zIndex = getComputedStyle(currentElement).getPropertyValue('z-index');
        if (zIndex !== 'auto' && !isNaN(zIndex)) {
        zIndexValues.push({element:currentElement, zindex:parseInt(zIndex)});
        }

        currentElement = currentElement.parentElement;
    }

    return zIndexValues;
}

const Index = (props) => {
    const lang = props.Lang ? props.Lang : 'de';
    const color = props.Color;
    const cameras = props.Cameras;
    const copyrightlink = props.Copyrightlink;
    const copyrighttext = props.Copyrighttext;
    const copyrighttitle = props.Copyrighttitle;
    //const acclat = props.Acclat;
    //const acclon = props.Acclon;
    const accomodation = props.Accomodation;
    const nofollow = props.Nofollow;
    const ref = useRef(null);
    const refMainWrap = useRef(null);

    const [originalZindex, setOriginalZindex] = useState(null);

    const handleResize = (isMaximized) => {
        //console.log('isMaximized',isMaximized);

        if(!originalZindex){
            var parentElem = document.querySelector('#original_container_tn-webcam-widget');
            if(!parentElem){
                const newElement = document.createElement('div');
                newElement.id = 'original_container_tn-webcam-widget';
                ref.current.parentNode.insertAdjacentElement('afterend', newElement);
                setOriginalZindex(getParentZIndexValues(newElement));
            } else {
                setOriginalZindex(getParentZIndexValues(parentElem));
            }
        }  
        if(isMaximized === true){
            ref.current.parentNode.classList.add('maximized');
            document.body.classList.add('has-webcam-noscroll');
            document.getElementsByTagName( 'html' )[0].classList.add('has-webcam-noscroll');
            originalZindex.forEach(val => {
                val.element.style.zIndex = 9999999;
            }); 
            setTimeout(()=>{
					window.dispatchEvent(new Event('resize'));
				},
				500
			);
        } else if(isMaximized === false){
            ref.current.parentNode.classList.remove('maximized');
            document.body.classList.remove('has-webcam-noscroll');
            document.getElementsByTagName( 'html' )[0].classList.remove('has-webcam-noscroll');
            originalZindex.forEach(val => {
                val.element.style.zIndex = val.zindex;
            }); 
        }
        const myTimeout = setTimeout(()=>{
            if(refMainWrap.current.offsetWidth > 0){   
                ref.current.classList.remove('maxwidth_1920px');  
                ref.current.classList.remove('maxwidth_1600px'); 
                ref.current.classList.remove('maxwidth_1200px'); 
                ref.current.classList.remove('maxwidth_1024px');
                ref.current.classList.remove('maxwidth_767px');
                ref.current.classList.remove('maxwidth_420px');             
                if(refMainWrap.current.offsetWidth > 1920){
                    ref.current.classList.remove('maxwidth_1920px');  
                    ref.current.classList.remove('maxwidth_1600px'); 
                    ref.current.classList.remove('maxwidth_1200px'); 
                    ref.current.classList.remove('maxwidth_1024px');
                    ref.current.classList.remove('maxwidth_767px');
                    ref.current.classList.remove('maxwidth_420px');
                } else if(refMainWrap.current.offsetWidth > 1600){
                    ref.current.classList.add('maxwidth_1920px');     
                } else if(refMainWrap.current.offsetWidth > 1200){
                    ref.current.classList.add('maxwidth_1920px');
                    ref.current.classList.add('maxwidth_1600px');                 
                } else if(refMainWrap.current.offsetWidth > 1024){
                    ref.current.classList.add('maxwidth_1920px');
                    ref.current.classList.add('maxwidth_1600px');
                    ref.current.classList.add('maxwidth_1200px');                 
                } else if(refMainWrap.current.offsetWidth > 767){
                    ref.current.classList.add('maxwidth_1920px');
                    ref.current.classList.add('maxwidth_1600px');
                    ref.current.classList.add('maxwidth_1200px'); 
                    ref.current.classList.add('maxwidth_1024px');                
                } else if(refMainWrap.current.offsetWidth > 420){
                    ref.current.classList.add('maxwidth_1920px');
                    ref.current.classList.add('maxwidth_1600px');
                    ref.current.classList.add('maxwidth_1200px'); 
                    ref.current.classList.add('maxwidth_1024px'); 
                    ref.current.classList.add('maxwidth_767px');                
                } else {
                    ref.current.classList.add('maxwidth_1920px');
                    ref.current.classList.add('maxwidth_1600px');
                    ref.current.classList.add('maxwidth_1200px'); 
                    ref.current.classList.add('maxwidth_1024px'); 
                    ref.current.classList.add('maxwidth_767px'); 
                    ref.current.classList.add('maxwidth_420px');
                }                
            }
        },500);
        //clearTimeout(myTimeout);
    }

    useLayoutEffect(() => {        
        window.addEventListener('resize', handleResize);
        if(ref.current.offsetWidth > 0){
            handleResize();
        }
    }, []);
    
    return (

        <Provider store={store}>

            <div ref={ref} >

            <div className="webcame-loader">
                <div className="webcame-loader-inner">
                <div className="circle"></div>
                <div className="circle"></div>
                <div className="circle"></div>
                <div className="shadow"></div>
                <div className="shadow"></div>
                <div className="shadow"></div>
                </div>
            </div>

                <TnWebCam
                    handleResize={handleResize} 
                    refMainWrap={refMainWrap}
                    lang={lang} 
                    color={color} 
                    accomodation={accomodation} 
                    cameras={cameras}
                    copyrightlink={copyrightlink} 
                    copyrighttext={copyrighttext}
                    copyrighttitle={copyrighttitle}
                    nofollow={nofollow}
                    ></TnWebCam>
        
            </div>

        </Provider>

    );
};


Index.propTypes = {
    class: PropTypes.string,
    lang: PropTypes.string,
    color: PropTypes.string,
    //acclat: PropTypes.string,
    //acclon: PropTypes.string,
    accomodation: PropTypes.string,
    cameras: PropTypes.string,
    copyrightlink: PropTypes.string,
    copyrighttext: PropTypes.string,
    copyrighttitle: PropTypes.string,
    nofollow: PropTypes.string,
}


customElements.define(
    "tn-webcam-widget",
    reactToWebComponent(Index, React, ReactDOM, {
        props: ["Lang", "Color", "Accomodation", "Cameras", "Copyrightlink", "Copyrighttext", "Copyrighttitle", "Nofollow"],
    }),
)
